import React from "react";
import { useHistory } from "react-router-dom";

import { Button, TextField, Box } from "@mui/material";

import { useAuthContext } from "../../context";

const Login = (): React.ReactElement => {
  const { token, loginData, setLoginData, login, loginFeedback, expiredMessage } = useAuthContext();

  const history = useHistory();

  const loginDataFN = (data: string, type: string) => {
    setLoginData({ ...loginData, [type]: data });
  };

  setTimeout(() => {
    token !== "" && history.replace("/");
  }, 100);

  return (
    <form className="login" onSubmit={() => login()}>
      <div>
        <div className={`expired ${expiredMessage && "extend"}`}>{expiredMessage}</div>

        <div className="title">Login</div>

        <Box>
          <TextField
            variant="standard"
            label="Username"
            id="username"
            onChange={(e) => loginDataFN(e.target.value, "email")}
            value={loginData.email}
            fullWidth
          />
        </Box>

        <Box>
          <TextField
            variant="standard"
            label="Password"
            type="password"
            id="password"
            onChange={(e) => loginDataFN(e.target.value, "password")}
            value={loginData.password}
            fullWidth
            sx={{ marginTop: 2 }}
          />
        </Box>

        <div style={{ marginTop: 15, textAlign: "right" }}>
          {loginFeedback} <Button onClick={() => login()}>Login</Button>
        </div>
      </div>
    </form>
  );
};

export default Login;
